import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TalentQualifications({ certificates = [], status, loading = false }) {
  const { t } = useTranslation('sourcing');
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? certificates : certificates.slice(0, 1);
  return (
    <div className="tp-career-section-group">
      <h4 className="tp-ai-sub-header">{t('talentProfile.professionalQualifications', 'Professional qualifications & certifications')}</h4>
      {visible.map((cert, index) => (
        <div className="tp-timeline-item" key={`${cert.name}-${index}`}>
          <div className="tp-timeline-left">
            <div className={`tp-timeline-dot ${index ? 'past' : ''}`} />
            <div className="tp-timeline-line" />
          </div>
          <div className="tp-timeline-content">
            <h5 className="tp-role-title">{cert.name}</h5>
            <p className="tp-date-range">{[cert.issuer, cert.date].filter(Boolean).join(' • ')}</p>
            {cert.expiration_date && <p className="tp-date-range">{t('talentProfile.expires', 'Expires')}: {cert.expiration_date}</p>}
            {cert.source === 'education' && <p className="tp-description">{t('talentProfile.qualificationFromEducation', 'Listed under education; completion is not independently confirmed.')}</p>}
            {cert.field_of_study && <p className="tp-description">{cert.field_of_study}</p>}
            {cert.description && <p className="tp-description">{cert.description}</p>}
            {cert.credential_id && <p className="tp-date-range">{t('talentProfile.credentialId', 'Credential ID')}: {cert.credential_id}</p>}
            {/^https?:\/\//i.test(cert.credential_url || '') && (
              <a className="tp-description" href={cert.credential_url} target="_blank" rel="noopener noreferrer">
                {t('talentProfile.viewCredential', 'View credential')}
              </a>
            )}
          </div>
        </div>
      ))}
      {certificates.length > 1 && <button type="button" className="tp-header-btn" onClick={() => setExpanded(!expanded)}>
        {expanded ? t('talentProfile.showLess', 'Show Less') : t('talentProfile.loadAll', 'Load All')}
      </button>}
      {loading ? <p className="tp-description" role="status">{t('talentProfile.loadingQualifications', 'Loading qualification details…')}</p>
        : status === 'unavailable' || status === 'not_requested' ? <p className="tp-description">{t('talentProfile.qualificationsUnavailable', 'Additional certificate details are unavailable.')}</p>
          : certificates.length === 0 && <p className="tp-description">{t('talentProfile.noCertifications', 'No certifications listed.')}</p>}
    </div>
  );
}
